// Our web app's Firebase configuration
const firebaseConfig = {
    apiKey: 'AIzaSyDPeqlTIG3j9g3zAvL7CmV-mzSb-BZNfF4',
    authDomain: 'tourism-by-mominur.firebaseapp.com',
    projectId: 'tourism-by-mominur',
    storageBucket: 'tourism-by-mominur.appspot.com',
    messagingSenderId: '234662928958',
    appId: '1:234662928958:web:9e09a6076839683645676f',
  };



export default firebaseConfig;